import { Constants } from 'app/core/constants';
import { AuthActions } from '../actions';
import {
  AuthAction,
} from '../constants';
import {
  IAuthState,
  initialAuthState,
} from '../state/auth.state';
import { User } from '../../models';

export const authReducer = (
  state = initialAuthState,
  action: AuthActions
): IAuthState => {

  switch (action.type) {

    case AuthAction.AuthUserSuccess: {
      console.log('AuthUserSuccess', action.data);
      const { user, access, refresh } = action.data;
      
      // Adaptamos solo los campos mínimos necesarios
      const adaptedUser: any = {
        id: user.id,
        email: user.email,
        username: user.username,
        roleId: user.role_id,
        typeId: user.role_id, // Mantenemos typeId para compatibilidad
        name: user.first_name || user.username,
        state: 1,
      };
    
      // Guardamos tokens
      localStorage.setItem(Constants.TOKEN, access);
      localStorage.setItem(Constants.USER, JSON.stringify(adaptedUser));
      
      return {
        ...state,
        token: access,
        refreshToken: refresh,
        user: adaptedUser,
      };
    }

    case AuthAction.RequestUserPasswordSuccess: {
      // const {oauth} = data.data;
      // const {token, user} = oauth;
      // localStorage.setItem(Constants.TOKEN, token);
      // localStorage.setItem(Constants.USER, JSON.stringify(user));
      return {
        ...state,
        // token: token,
        // user: user,
      };
    }

    case AuthAction.RequestUserPasswordError: {
      return {
        ...state,
      };
    }

    case AuthAction.ResetUserPasswordSuccess: {
      // const data = action.data;
      // const {oauth} = data.data;
      // const {token, user} = oauth;
      // localStorage.setItem(Constants.TOKEN, token);
      // localStorage.setItem(Constants.USER, JSON.stringify(user));
      return {
        ...state,
        // token: token,
        // user: user,
      };
    }

    case AuthAction.ResetUserPasswordError: {
      return {
        ...state,
      };
    }

    case AuthAction.LogoutUserSuccess: {
      localStorage.removeItem(Constants.TOKEN);
      localStorage.removeItem(Constants.USER);
      return {
        ...state,
        user: null,
        token: null,
      };
    }

    case AuthAction.LogoutUserError: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }

};
